'use strict'

const GET_ALL_DEVICES_FOR_USER_REQUEST = "GET_ALL_DEVICES_FOR_USER_REQUEST";
const GET_ALL_DEVICES_FOR_USER_SUCCESS = "GET_ALL_DEVICES_FOR_USER_SUCCESS";
const GET_ALL_DEVICES_FOR_USER_FAILURE = "GET_ALL_DEVICES_FOR_USER_FAILURE";
const RESET_DEVICES_DATA_FETCH_FAILED_FLAG = "RESET_DEVICES_DATA_FETCH_FAILED_FLAG";

const ERROR_SAVE_USER_PREFERENCE_MODAL = "ERROR_SAVE_USER_PREFERENCE_MODAL";
const HOME_PAGE_USER_PREFERENCE_SAVED = "HOME_PAGE_USER_PREFERENCE_SAVED";
const HOME_PAGE_REPORT_ID_API_REQUEST = 'HOME_PAGE_REPORT_ID_API_REQUEST';
const HOME_PAGE_REPORT_ID_API_SUCCESS = 'HOME_PAGE_REPORT_ID_API_SUCCESS';
const HOME_PAGE_REPORT_ID_API_FAILURE = 'HOME_PAGE_REPORT_ID_API_FAILURE';
const HOME_PAGE_GROUP_ID_API_REQUEST='HOME_PAGE_GROUP_ID_API_REQUEST';
const HOME_PAGE_GROUP_ID_API_SUCCESS = 'HOME_PAGE_GROUP_ID_API_SUCCESS';
const HOME_PAGE_GROUP_ID_API_FAILURE = 'HOME_PAGE_GROUP_ID_API_FAILURE';

const POWERBI_GROUP_URL ='https://api.powerbi.com/v1.0/myorg/groups';
const HOME_PAGE_LIST_VIEW_API_REQUEST = 'HOME_PAGE_LIST_VIEW_API_REQUEST';
const HOME_PAGE_LIST_VIEW_API_SUCCESS = 'HOME_PAGE_LIST_VIEW_API_SUCCESS';
const HOME_PAGE_LIST_VIEW_API_FAILURE = 'HOME_PAGE_LIST_VIEW_API_FAILURE';
const HOME_PAGE_LIST_VIEW_LOAD_MORE = 'HOME_PAGE_LIST_VIEW_LOAD_MORE';
const HOME_PAGE_LIST_VIEW_LOAD_MORE_REQUEST = 'HOME_PAGE_LIST_VIEW_LOAD_MORE_REQUEST';
const HOME_PAGE_LIST_VIEW_LOAD_MORE_FAILURE = 'HOME_PAGE_LIST_VIEW_LOAD_MORE_FAILURE';
const HOME_PAGE_CRITICAL_COUNT = "HOME_PAGE_CRITICAL_COUNT";
const HOME_PAGE_WARNING_COUNT = "HOME_PAGE_WARNING_COUNT";
const HOME_PAGE_PATIENT_TEST_COUNT="HOME_PAGE_PATIENT_TEST_COUNT";
const HOME_PAGE_CONNECTION_RATE="HOME_PAGE_CONNECTION_RATE";

const HOME_PAGE_WATCHLIST_ACTION_REQUEST = "HOME_PAGE_WATCHLIST_ACTION_REQUEST";
const HOME_PAGE_WATCHLIST_ACTION_SUCCESS = "HOME_PAGE_WATCHLIST_ACTION_SUCCESS";
const HOME_PAGE_WATCHLIST_ACTION_FAILED = "HOME_PAGE_WATCHLIST_ACTION_FAILED";
const HOME_PAGE_WATCHLIST_ACCESS_DENIED = "HOME_PAGE_WATCHLIST_ACCESS_DENIED";
const HOME_PAGE_WATCHLIST_RESET_ACTION_STATUS = "HOME_PAGE_WATCHLIST_RESET_ACTION_STATUS";

const HOME_PAGE_DROPDOWN_LIST_REQUEST = "HOME_PAGE_DROPDOWN_LIST_REQUEST";
const HOME_PAGE_DROPDOWN_LIST_SUCCESS = "HOME_PAGE_DROPDOWN_LIST_SUCCESS";
const HOME_PAGE_DROPDOWN_LIST_FAILURE = "HOME_PAGE_DROPDOWN_LIST_FAILURE";

export {
    GET_ALL_DEVICES_FOR_USER_REQUEST,
    GET_ALL_DEVICES_FOR_USER_SUCCESS,
    GET_ALL_DEVICES_FOR_USER_FAILURE,
    RESET_DEVICES_DATA_FETCH_FAILED_FLAG,
    ERROR_SAVE_USER_PREFERENCE_MODAL,
    HOME_PAGE_USER_PREFERENCE_SAVED,
    HOME_PAGE_REPORT_ID_API_REQUEST,
    HOME_PAGE_REPORT_ID_API_SUCCESS ,
    HOME_PAGE_REPORT_ID_API_FAILURE,
    HOME_PAGE_GROUP_ID_API_REQUEST,
    HOME_PAGE_GROUP_ID_API_SUCCESS ,
    HOME_PAGE_GROUP_ID_API_FAILURE,
    POWERBI_GROUP_URL,
    HOME_PAGE_LIST_VIEW_API_REQUEST,
    HOME_PAGE_LIST_VIEW_API_SUCCESS,
    HOME_PAGE_LIST_VIEW_API_FAILURE,
    HOME_PAGE_LIST_VIEW_LOAD_MORE,
    HOME_PAGE_LIST_VIEW_LOAD_MORE_REQUEST,
    HOME_PAGE_LIST_VIEW_LOAD_MORE_FAILURE,
    HOME_PAGE_CRITICAL_COUNT,
    HOME_PAGE_WARNING_COUNT,
    HOME_PAGE_PATIENT_TEST_COUNT,
    HOME_PAGE_CONNECTION_RATE,
    HOME_PAGE_WATCHLIST_ACTION_REQUEST,
    HOME_PAGE_WATCHLIST_ACTION_SUCCESS,
    HOME_PAGE_WATCHLIST_ACTION_FAILED,
    HOME_PAGE_WATCHLIST_ACCESS_DENIED,
    HOME_PAGE_DROPDOWN_LIST_REQUEST,
    HOME_PAGE_DROPDOWN_LIST_SUCCESS,
    HOME_PAGE_DROPDOWN_LIST_FAILURE,
    HOME_PAGE_WATCHLIST_RESET_ACTION_STATUS
}
